import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

export default class extends BridgeComponent {
  static component = 'share';

  share() {
    const url = this.bridgeElement.bridgeAttribute('url') || window.location.href;
    this.send('share', { url }, ({ data: { result } }) => {
      if (result) {
        console.log('Share successful');
      } else {
        console.error('Share failed');
      }
    });
  }
}
